export const EMAIL_RE = new RegExp(/\S+@\S+\.\S+/);
export const PHONE_NUMBER_RE = new RegExp(/^([0-9]|x){10}$/);
